import { render, staticRenderFns } from "./UplimitStep.vue?vue&type=template&id=641d63a1"
import script from "./UplimitStep.vue?vue&type=script&lang=js"
export * from "./UplimitStep.vue?vue&type=script&lang=js"
import style0 from "./UplimitStep.vue?vue&type=style&index=0&id=641d63a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports